import { createRoot } from 'react-dom/client'
import 'admination-design-system'
import { boot } from './boot'
import { initI18n } from './core/i18n'

initI18n()
boot(createRoot(document.getElementById('root')!))
